import { FunctionComponent } from 'react';
import { default as JGLoading } from '@justgiving/loading';
import styled from 'styled-components';

export const LoadingPage: FunctionComponent<React.PropsWithChildren<
  unknown
>> = () => {
  return (
    <LoadingScreenContainer>
      <JGLoading />
    </LoadingScreenContainer>
  );
};

const LoadingScreenContainer = styled.div`
  align-self: center;
  flex: 1;
`;
